"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorFormatter = void 0;
class ColorFormatter {
    static arrayToRgbString(rgbArray) {
        return `rgb(${rgbArray[0]}, ${rgbArray[1]}, ${rgbArray[2]})`;
    }
    static arrayToHslString(hslArray) {
        return `hsl(${hslArray[0]}deg, ${hslArray[1]}%, ${hslArray[2]}%)`;
    }
}
exports.ColorFormatter = ColorFormatter;
